import { DisabledFOD } from "./DisabledFOD";
import { EnabledFOD } from "./EnabledFOD";
export const FirstOrderDiscount = {
    create(params) {
        // FIXME Refactor
        // TODO: Storage service with multiple providers
        // (localStorage for web, AsyncStorage for React Native?)
        const FODStorageKey = "claimedFod";
        const isClaimed = window.localStorage.getItem(FODStorageKey) === "true";
        const setIsClaimed = (value) => window.localStorage.setItem(FODStorageKey, JSON.stringify(value));
        const isFODDisabled = isClaimed || !params.restaurantEnableFod || params.isQrWaiterOrder;
        return isFODDisabled
            ? new DisabledFOD()
            : new EnabledFOD({
                restaurantId: params.restaurantId,
                validatePhoneService: params.validatePhoneService,
                checkoutService: params.checkoutService,
                contactDetails: params.contactDetails,
                setIsClaimed,
            });
    },
};
